import { BaseService } from "core/services";
import { ConfirmingReportItemRouteService } from "application/confirming-report/services";

class ConfirmingReportItemService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ConfirmingReportItemRouteService());
	}

	async findGrouped(resource){
        const url = this.routeService.findGrouped(resource);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    getPumpAndPoleItems(filter) {
        const url = this.routeService.getPumpAndPoleItems(filter);

        return this.apiClient.get(url);
    }

    getSpecificConfirmingStatusItems(filter) {
        const url = this.routeService.getSpecificConfirmingStatusItems(filter);

        return this.apiClient.get(url);
    }
}

export default ConfirmingReportItemService;